import React from "react";
import ThumbsUpIcon from "@public/images/thumbs-up-icon.svg";
import { PrimaryButton } from "@acko-tech/building-blocks.ui.button";
import { Flex, styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import { getInrFormat } from "@utils/inrFormatter";
import { PrimaryText } from "@widgets/multipleCouponCard/styles";
import Modal from "@components/modal";

const PRIMARY_CTA_TEXT = "OK";

const CounponAppliedText = styled(Text)`
  color: #0b753e;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  margin-top: 1.75rem;
  margin-bottom: 1rem;
`;

const CouponPremiumText = styled(PrimaryText)`
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
`;

const CouponSuccessModal = ({
    appliedCoupon,
    showModal,
    setShowModal,
    couponDiscountAmount
}) => {
    const { code, coupon_display_name } = appliedCoupon || {};
    return (
        <Modal showModal={showModal} setShowModal={setShowModal} hideCloseButton>
            <Flex
                flexDirection="column"
                alignItems="center"
                style={{ marginBottom: "2rem" }}
            >
                <ThumbsUpIcon />
                <CounponAppliedText>
                    {coupon_display_name || code} applied!
                </CounponAppliedText>
                <CouponPremiumText />
                <CouponPremiumText>
                    You saved ₹{getInrFormat(couponDiscountAmount)} on your premium
                </CouponPremiumText>
            </Flex>
            <PrimaryButton
                onClick={() => {
                    setShowModal(false);
                }}
            >
                {PRIMARY_CTA_TEXT}
            </PrimaryButton>
        </Modal>
    );
};

export default CouponSuccessModal;
